<template>
  <div class="btn-group">
    <button v-if="!isPublishing"  @click="confirmPublish()" :class="getButtonClass()" :title="title">
      <i class="icon-circle-arrow-up"></i>
      Publish configuration
    </button>
    <ProgressBar v-if="isPublishing" :totalItems="totalGroups" :completedItems="completedGroups"/>
  </div>
  <BModal
    v-model="isModalVisible"
    @ok="publish"
    ok-title="Yes"
    cancel-title="No"
    title="Publish configuration"
    :lazy="true"
  >Are you sure you want to publish the configuration?</BModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import LoadingAnimation from '~/windowEvents/LoadingAnimation';
import ProgressBar from '~/components/ProgressBar.vue';

export default defineComponent({
  name: 'BaseConfigurationPublisher',
  components: {
    ProgressBar,
  },
  data(): {
    isButtonDisabled: boolean,
    isPublishing: boolean,
    isModalVisible: boolean,
    totalGroups: number,
    completedGroups: number,
    title: string,
  } {
    return {
      isButtonDisabled: false,
      isPublishing: false,
      isModalVisible: false,
      totalGroups: 0,
      completedGroups: 0,
      title: 'Publish configuration',
    };
  },

  methods: {
    getButtonClass(): string {
      return 'btn btn-' + (this.isButtonDisabled ? 'secondary' : 'primary');
    },
    confirmPublish(): void {
      if (this.getButtonClass().includes('primary')) {
        this.showModal();
      }
    },
    async publish(): Promise<void> {
      this.turnPublishingOn();
      await LoadingAnimation.perform(this.runPublishing);
      this.turnPublishingOff();
    },
    async runPublishing(): Promise<void> {
      throw new Error('not implemented');
    },
    async setButtonStatus() {
      throw new Error('not implemented');
    },
    showModal() {
      this.isModalVisible = true;
    },
    turnPublishingOn() {
      this.isPublishing = true;
      this.isButtonDisabled = true;
    },
    turnPublishingOff() {
      this.isPublishing = false;
      this.completedGroups = 0;
    },
  },
});
</script>
